const CartIcon = ({
  color,
  width = 32, 
  height = 32, 
  uniqueId,
  radiosColor1, 
  radiosColor2
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M12.6665 20C11.9332 20 11.3398 20.6 11.3398 21.3333C11.3398 22.0667 11.9332 22.6667 12.6665 22.6667C13.3998 22.6667 13.9998 22.0667 13.9998 21.3333C13.9998 20.6 13.3998 20 12.6665 20ZM8.6665 9.99999C8.6665 10.3667 8.9665 10.6667 9.33317 10.6667H9.99984L12.3998 15.7267L11.4998 17.3533C11.0132 18.2467 11.6532 19.3333 12.6665 19.3333H19.9998C20.3665 19.3333 20.6665 19.0333 20.6665 18.6667C20.6665 18.3 20.3665 18 19.9998 18H12.6665L13.3998 16.6667H18.3665C18.8665 16.6667 19.3065 16.3933 19.5332 15.98L21.9198 11.6533C22.1665 11.2133 21.8465 10.6667 21.3398 10.6667H11.4732L11.0265 9.71333C10.9198 9.47999 10.6798 9.33333 10.4265 9.33333H9.33317C8.9665 9.33333 8.6665 9.63333 8.6665 9.99999ZM19.3332 20C18.5998 20 18.0065 20.6 18.0065 21.3333C18.0065 22.0667 18.5998 22.6667 19.3332 22.6667C20.0665 22.6667 20.6665 22.0667 20.6665 21.3333C20.6665 20.6 20.0665 20 19.3332 20Z" fill={color}/>
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1} />
          <stop offset="0.885417" stopColor={radiosColor2} />
        </linearGradient>
      </defs>
      </svg>
  )
}

export default CartIcon;
